module.exports = __webpack_public_path__ + "img/bj.b8588f3c.png";